import { Label } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';
import styles from './SearchInfo.css';
import { userProfileSearchInfoSelector } from '../../../../../selectors/userProfile';
import { AboutTabSection } from '../AboutTabSection';

export const SearchInfo = () => {
  const searchInfo = useSelector(userProfileSearchInfoSelector);

  if (!searchInfo?.tags.length) {
    return null;
  }

  const { title, tags } = searchInfo;

  return (
    <AboutTabSection title={title} testId="SearchInfo">
      <div className={styles['tags']}>
        {tags.map((tag, index) => (
          <Label
            background="accent-ghost-secondary"
            color="text-primary-default"
            key={`search_info_tag_label_${index}`}
          >
            {tag}
          </Label>
        ))}
      </div>
    </AboutTabSection>
  );
};
